import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { css } from '@emotion/react';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import { ManageSeatsButton } from './add-seats-modal';
import { useMetaSelector } from '../../../meta/reducer';
import {
  stroot,
  subscription as subscriptionAPI,
  organisation as orgAPI,
} from '@birdi/js-sdk';

const seatsInfoStyle = (theme: BirdiTheme) => css`
  display: flex;
  // width: fit-content;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  background-color: ${theme.lightOcean};
  border-radius: 5px;
  margin-bottom: 1em;
  @media (max-width: ${breakpoints.m}) {
    margin: 0;
  }
`;

interface SeatsBadgeProps {
  modalOpen: boolean;
  setModalOpen: (value: boolean) => void;
}

/**
 * This component shows how many seats used & in total
 */
export const SeatsBadge = ({ modalOpen, setModalOpen }: SeatsBadgeProps) => {
  const navigate = useNavigate();
  const meta = useMetaSelector();
  const [seatsUsage, setSeatsUsage] = useState<{
    userSeatsUsed: number;
    guestSeatsUsed: number;
  } | null>(null);
  const [seatLimits, setSeatLimits] = useState<{
    userSeatsLimit: number;
    guestSeatsLimit: number;
  } | null>(null);
  useEffect(() => {
    orgAPI.getSeatsCount(stroot('2oasby')).then((res) => {
      setSeatsUsage({
        userSeatsUsed: res.body?.userCount,
        guestSeatsUsed: res.body?.guestCount,
      });
    });
    subscriptionAPI
      .getCurrentPlan(stroot('phahc4'))
      .then((res) => {
        setSeatLimits({
          userSeatsLimit: res.body?.basePlan?.userLimitSeats,
          guestSeatsLimit: res.body?.basePlan?.guestsLimitSeats,
        });
      })
      .catch(() => {
        // Expecting this to catch during processing preview or when
        // external billing is true, for now
      });
  }, []);

  return (
    <div>
      <>
        <div css={seatsInfoStyle}>
          <span
            css={css`
              margin-right: 1em;
            `}
          >{`Seats    ${seatsUsage?.userSeatsUsed}/${seatLimits?.userSeatsLimit ?? 'Unlimited'} used`}</span>

          <span>{`Guest Seats    ${seatsUsage?.guestSeatsUsed}/${seatLimits?.guestSeatsLimit ?? 'Unlimited'} used`}</span>
          <button
            type="button"
            css={(theme: BirdiTheme) => css`
              color: ${theme.deepOcean};
              text-decoration: underline;
            `}
            onClick={() => navigate('/billing/options')}
          >
            Upgrade
          </button>
        </div>
      </>
    </div>
  );
};
